// removed by extract-text-webpack-plugin
module.exports = {"search-content-label":"index__search-content-label___kxZG2","search-content-name":"index__search-content-name___1GCaO"};


//////////////////
// WEBPACK FOOTER
// ./src/views/AttachAccount/index.less
// module id = 1830
// module chunks = 3